// Copyright (C) 2020 GanttProject Cloud OU
// Author: Dmitry Barashev (dbarashev@ganttproject.cloud)
//
// This is the entry point to a family of pages nested under /me URL
// The page to show is chosen with the help of client-side router.

import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import DashboardApp, { setupVueComponents } from './DashboardApp.vue';
import { registerUiDirectives } from './utils/Ui';
import App from '@/RouterApp.vue';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/me/billing',
      name: 'billing',
      component: DashboardApp,
    },
    {
      path: '/me/settings',
      name: 'settings',
      component: DashboardApp,
    },
    {
      path: '/me',
      name: 'teams',
      component: DashboardApp,
    },
    {
      path: '/me/:pathMatch(.*)*',
      redirect: '/me',
    },
  ],
});

const app = createApp(App);
app.use(router);
setupVueComponents(app);
registerUiDirectives(app);
app.mount('#app');
